"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = function Close() {
  return _react2.default.createElement(
    "g",
    { id: "close" },
    _react2.default.createElement("polygon", { id: "Shape", points: "502 50 452 0 252 200 52 0 2 50 202 250 2 450 52 500 252 300 452 500 502 450 302 250" })
  );
};

exports.default = Close;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Close.js
// module id = 2936
// module chunks = 4